import React from 'react'

const NoSelectUser = () => {
    return <div>NoSelectUser</div>
}

export default NoSelectUser
